module.exports = __webpack_public_path__ + "static/media/3.f3bbf256.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/3.png
// module id = 1652
// module chunks = 0